<script>
// import {cloneDeep} from 'lodash'
import { Icon } from 'iview'
import Page from '@/components/page'
import {columnsTable} from './table'
import {mapGetters, mapMutations} from 'vuex'
import dragMixins from '@/mixins/drag-table'
import {interceptorFactory, isIE} from '@/utils'
import Modal from './modal'
import Layout from './layout'
import {enableDynamic} from '@/config'
const operateText = '操作'
const ieClass = isIE() ? 'iv-drag-table-ie' : ''
const admiunWhiteCode = ['yemianpeizhi']
//const isPod = process.env.NODE_ENV === 'production'
export default {
  mixins: [dragMixins],
  props: {
    noUrl: {
      type: Boolean,
      default: false
    },
    searchInterceptor: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array
    },
    staticData: {
      type: Boolean,
      default: false
    },
    noSearch: {
      type: Boolean,
      default: false
    },
    noSendDynamic: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    showPage: {
      type: Boolean,
      default: true
    },
    showRadioSelect: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: true
    },
    showSort: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: true
    },
    fixedSelection: {
      type: Boolean,
      default: false
    },
    fixedDrag: {
      type: Boolean,
      default: false
    },
    fixedSort: {
      type: [Boolean, String],
      default: false
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showSave: {
      type: Boolean,
      default: true
    },
    disabledDrag: {
      type: Boolean,
      default: true
    },
    sortableHandle: {
      type: String,
      default: 'ivu-table-row'
    },
    noDataText: {
      type: String,
      default: '暂无数据'
    },
    //向下兼容，忽略此属性
    compatible: {
      type: Boolean,
      default: true
    },
    method: {
      type: String,
      default: 'GET'
    },
    url: {
      type: String,
      // required: true,
      default: ''
    },
    rowCheck: {
      type: Boolean,
      default: false
    },
    showSetButton: {
      type: Boolean,
      default: true
    },
    menuName: {
      type: String,
      default: ''
    },
    sortableConfig: {
      type: Object,
      default () {
        return {}
      }
    },
    configItem: {
      type: Object,
      default () {
        return {}
      }
    },
    getAction: {
      type: Function
    },
    immediateForce: { //一进页面便调用一次刷新
      type: Boolean,
      default: false
    },
    setCustomHeight: {
      type: Function
    },
    dynamicConfig: {
      type: Boolean,
      default: false
    },
    watchColumn: {
      type: Boolean,
      default: true
    }
  },
  inject: {
    setSortIndex: {
      default () {
        return function () {}
      }
    },
    interceptor: {
      default () {
        return {}
      }
    },
    emitSyncHeight: {
      default () {
        return function () {}
      }
    }
  },
  data () {
    return {
      showSetting: false,
      uniClass: `iv-sortable-${this._uid}`,
      dataTable: [],
      loading: true,
      data: [],
      total: 1,
      privateColumns: null,
      columnsTable: [],
      currentIndex: NaN,
      height: void 0,
      dynamicTableStatus: !enableDynamic, // 动态表格列是否开启，开启后防止多次渲染列表，造成性能冗余
      isWipeData: false //是否将data设为空 为浏览权限而加
    }
  },
  computed: {
    ...mapGetters({
      storePageSize: 'pageSize'
    })
  },
  components: {
    Page
  },
  created () {
    let that = this
    // 创建一个空数组
    this.emptyArray = Object.freeze([])
    // 初始化搜索map
    this.tableModal = {}
    this.searchKeyMap = {}
    this.params = {}
    this.currentPage = 1
    this.requestCount = []
    this.menuCode = this.menuName
    this.defaultInterceptor = {
      request: {
        resolve: () => {}
      },
      response: {
        resolve: (data) => {
          if (!that.noSearch) {
            const resData = data.data.data
            if (resData) { //为啥加这个，影响查询条件，没有结果的时候，不显示搜索行  && resData.length
              data.data.data = [{}, ...data.data.data]
            }
          }
          return data
        }
      }
    }
    this.createdInterceptor()
    if (this.immediateForce || (this.tableData && this.tableData.length)) {
      this.forceRender()
    }
  },
  mounted () {
    this.checkFixSearchRow() && this.fixSearchRowCheckbox()
    this.$attrs.immediate && this.forceRender()
  },
  updated () {
    this.checkFixSearchRow() && this.fixSearchRowCheckbox()
  },
  watch: {
    '$store.state.roleCode': {
      handler (val) {
        val.map(item => {
          if (admiunWhiteCode.includes(item)) {
            this.showSetting = true
          }
        })
      }
    },
    tableData (newVal) {
      this.forceRender()
    },
    data (newVal) {
      if (!this.noSearch) {
        // 行内新增时 新增行和搜索行交换
        if ((newVal[0] && newVal[0]._isAdd) && (newVal[1] && !newVal[1]._isAdd)) {
          [newVal[0], newVal[1]] = [newVal[1], newVal[0]]
        }
        if (newVal) {
          this.dataTable = newVal
        }
      }
      if (newVal) {
        this.dataTable = newVal
      }
    },
    disabledDrag (newVal) {
      if (newVal) {
        this.sortableInstance && this.sortableInstance.destroy()
        this.sortableInstance = null
      }
      this.columnsTable = columnsTable.apply(this, [this.privateColumns || this.columns])
    },
    columns: {
      handler () {
        if (this.watchColumn) {
          this.columnsTable = columnsTable.apply(this, [this.privateColumns || this.columns])
        }
      },
      immediate: true
    },
    menuName (val) {
      this.menuCode = val
    }
  },
  render (c) {
    const TableVnode = c('Table', {
      class: `${this.getTipsClass()} iv-symbol-mb16 ${this.uniClass} ${ieClass} ${this.noSearch ? 'iv-drag-table iv-drag-table-no-search' : 'iv-drag-table iv-drag-table-has-search'}`,
      ref: 'Table',
      attrs: Object.assign({}, this.$attrs, this.$options.propsData, {
        loading: this.loading,
        border: true,
        stripe: false,
        data: this.isWipeData ? [] : this.data,
        columns: !this.dynamicTableStatus ? this.emptyArray : this.columnsTable,
        // TODO 暂时修改bug
        height: this.height
      }),
      on: {
        'on-selection-change': (list) => {
          this.tableSelectChange(list)
        },
        'on-select-cancel': (list, row) => {
          this.$emit('on-select-cancel', list, row)
        },
        'on-select': (list, row) => {
          this.$emit('on-select', list, row)
        },
        'on-select-all': (list) => {
          this.$emit('on-select-all', list)
        },
        'on-sort-change': (column) => {
          this.$emit('on-sort-change', column)
        },
        'on-row-click': (list, row) => {
          this.rowCheck && TableVnode.componentInstance.toggleSelect(row)
          this.$emit('on-row-click', list, row)
        },
        'on-column-width-resize': (newWidth, oldWidth, column, event) => {
          //带iview4.0BUG修复后，再从设置columns的拖拽宽度
          this.$emit('on-column-width-resize', newWidth, oldWidth, column, event)
        }
      }
    })
    // Page节点
    const PageVnode = this.data && this.data.length && this.showPage ? c(Page, {
      class: '',
      attrs: Object.assign({}, this.$attrs, {
        pageSize: this.$attrs.pageSize || this.storePageSize,
        total: this.total,
        current: this.currentPage
      }),
      on: {
        'on-page-size-change': (pageSize) => {
          this.changePageSize(pageSize)
        },
        'on-change': (page) => {
          this.changePage(page)
        }
      }
    }) : c('div')
    return c(Layout, [TableVnode, PageVnode, c(Modal, {
      ref: 'customModal',
      props: {
        menuCode: this.menuCode,
        ...this.$attrs
      },
      on: {
        'on-custom-table': this.onCustomTable
      }
    })])
  },
  methods: {
    ...mapMutations({
      mutationPageSize: 'PAGE_SIZE'
    }),
    setUrl (url) {
      this._url = url
    },
    setColumns (columns) {
      this.privateColumns = columns
      this.columnsTable = columnsTable.apply(this, [this.privateColumns || this.columns])
      if (this.dynamicConfig) {
        this.$store.state.roleCode.map(val => {
          if (admiunWhiteCode.includes(val)) {
            this.columnsTable[this.columnsTable.length - 1].renderHeader = (h, params) => {
              let column = params.column
              let icon = null
              if (column._index === this.columnsTable.length - 1) {
                icon = h('Icon', {
                  props: {
                    type: 'android-settings'
                  },
                  class: 'iv-pointer iv-pull-right iv-hover-color',
                  style: 'margin-top: 4px; margin-left: 8px;',
                  on: {
                    'click': (e) => {
                      this.showCustomModal(e)
                    }
                  }
                })
              }
              return h('div', [h('span', column.title), icon || ''])
            }
          }
        })
      }
    },
    setParams (params) {
      this.params = params
      this.currentPage = 1
      this.interceptorList.exec()
    },
    checkFixSearchRow () {
      if (this.noSearch) return false
      return !this.disabledDrag || ((this.showSelect || this.showRadioSelect) && this.data[0] && !this.data[0]._isAdd) || this.showSort
    },
    fixSearchRowCheckbox () {
      const td = this.$el.querySelector('.ivu-table-tbody tr td .ivu-table-cell')
      const replaceEl = td && td.children[0]
      if (!replaceEl) return
      const icon = document.createElement('i')
      icon.className = 'ivu-icon ivu-icon-search iv-fs-20'
      td.replaceChild(icon, replaceEl)
    },
    createdInterceptor () {
      this.interceptorList = interceptorFactory({
        request: {
          resolve: () => {
            return Promise.resolve().then(() => {
              this.dynamicTableStatus = false
              return (this.interceptor.request || this.defaultInterceptor.request).resolve(Object.assign({}, this.params))
            })
          },
          reject: (this.interceptor.request || {}).reject
        },
        dispatch: {
          resolve: this.resolveData,
          response: undefined
        },
        response: {
          resolve: (data) => {
            return Promise.resolve().then(() => {
              return (this.interceptor.response || this.defaultInterceptor.response).resolve(data, this)
            }).then(({data}) => {
              let that = this
              let fixedLeft = false
              // 动态字段筛选
              //let {item = {}} = data, columns, resTail
              let {groupItem} = data, columns, resTail
              this.columnsTable = columnsTable.apply(this, [this.privateColumns || this.columns])
              // if (enableDynamic && item?.columns) {
              if (enableDynamic && groupItem) {
                resTail = this.columnsTable[this.columnsTable.length - 1];
                // 配置操作列key
                ((resTail.isOperate || resTail.title === operateText) && (resTail.key = 'operate'))
                let result = []
                try {
                  //columns = typeof item.columns === 'string' ? JSON.parse(item.columns) : item.columns
                  columns = typeof groupItem === 'string' ? JSON.parse(groupItem) : groupItem
                  columns[0].forEach((column) => {
                    let res = {}
                    this.columnsTable.forEach(item => {
                      if (item.fixed == 'left') {
                        fixedLeft = true
                      }
                      if (item.key == column.value) {
                        item.title = column.title
                        item.fixed = column.patchCode
                        res = item
                      }
                    })
                    //let res = this.columnsTable.find(item => item.key === column.key)
                    if (!res) return
                    delete res.width
                    if (column.isEdit === false) {
                      delete column.render
                      delete res.render
                    }
                    result.push(Object.assign(res, column))
                  })
                  //头尾补充
                  if (!that.columnsTable[0].key === '_sort' || that.columnsTable[0].key === '_drag' || that.columnsTable[0].type === 'selection' || that.columnsTable[0].type === 'Radio') {
                    if (fixedLeft == true) {
                      this.columnsTable[0].fixed = 'left'
                    }
                    result.unshift(this.columnsTable[0])
                  }
                  //补充密级列
                  // let col = {
                  //   title: '密级',
                  //   width: 100,
                  //   [$field]: 'degreeSecrets'
                  // }
                  // col.render = (h, params) => {
                  //   return (
                  //     <div> <span>秘密</span></div>
                  //   )
                  // }
                  // result.splice(1, 0, col)
                  this.$store.state.roleCode.map(val => {
                    if (admiunWhiteCode.includes(val)) {
                      result[result.length - 1].renderHeader = (h, params) => {
                        let column = params.column
                        return (
                          <div>
                            <span>{column.title}</span>
                            { column._index === result.length - 1 && <Icon
                              onClick={e => this.showCustomModal(e)}
                              style="margin-top: 4px; margin-left: 8px;"
                              class="iv-pointer iv-pull-right iv-hover-color"
                              type="android-settings"></Icon>}
                          </div>
                        )
                      }
                    }
                  })
                  this.columnsTable = Object.assign([], result)
                } catch (e) {
                  console.error(`动态字段序列化失败，请查看drag-table-inine组件, ${e}`)
                }
              }
              this.$el.classList.remove('iv-transform-search-tip')
              this.dynamicTableStatus = true
              this.data = data.data
              this.total = data.count
              this.loading = false
              if (this.showSetButton && (groupItem == undefined || (groupItem && groupItem.length == 0)) && this.menuCode != undefined && this.menuCode != '') {
                this.$store.state.roleCode.map(val => {
                  if (admiunWhiteCode.includes(val)) {
                    this.columnsTable[this.columnsTable.length - 1].renderHeader = (h, params) => {
                      let column = params.column
                      return (
                        <div>
                          <span>{column.title}</span>
                          <Icon
                            onClick={e => this.showCustomModal(e)}
                            style="margin-top: 4px; margin-left: 8px;"
                            class="iv-pointer iv-pull-right iv-hover-color"
                            type="android-settings"></Icon>
                        </div>
                      )
                    }
                  }
                })
                this.columnsTable = Object.assign([], this.columnsTable)
              }
              // this.privateColumns = []
              // this.columnsTable.map(item => {
              //   if (item.key) {
              //     this.privateColumns.push(item)
              //   }
              // })
              //观察者触发
              this.$emit('on-list', this.data, data)
              this.emitSyncHeight(data, this)
              return this.data
            })
          },
          reject: (this.interceptor.response || {}).reject
        }
      })
    },
    resolveData () {
      this.loading = true
      if (this.noUrl || this.tableData || this.staticData) {
        if (this.noSendDynamic) {
          return this.getListGroupItem()
        }
        return Promise.resolve({
          data: {
            data: this.tableData,
            item: this.configItem
          }
        })
      } else {
        return this.getList()
      }
    },
    getListGroupItem () {
      return this.$ajax({
        url: 'module/config/getDetail',
        method: 'GET',
        data: {
          'current_group_code': this.menuCode || this.$route.name
        }
      }).then(({data}) => {
        return {
          data: {
            data: this.tableData,
            item: this.configItem,
            groupItem: data.groupItem
          }
        }
      })
    },
    getList (params = {}) {
      const data = Object.assign(this.$attrs.listData || {}, this.showPage != false ? {
        currentPage: this.currentPage,
        pageSize: this.$attrs.pageSize || this.storePageSize,
        'current_group_code': this.menuCode || this.$route.name
        //'menu-code1': this.menuCode || this.$route.name
      } : {
        currentPage: this.currentPage,
        'current_group_code': this.menuCode || this.$route.name
        //'menu-code1': this.menuCode || this.$route.name
      }, this.params, params)
      if (this.getAction) {
        return this.getAction(data).then(data => {
          return {
            data
          }
        })
      }
      // 废弃
      return this.$ajax({
        url: this._url || this.url,
        method: this.method,
        data
      })
    },
    getTipsClass () {
      if ((this.data != undefined && this.noSearch && !this.data.length) || (!this.noSearch && this.data.length === 1)) return 'iv-search-showtip'
      return ''
    },
    showCustomModal () {
      this.$methods('customModal', 'open', this.menuCode)
    },
    tableSelectChange (list) {
      this.$emit('on-selection-change', list)
    },
    changePageSize (pageSize) {
      this.mutationPageSize(pageSize)
      this.$attrs.pageSize && (this.$attrs.pageSize = pageSize)
      this.interceptorList.exec()
      this.$emit('on-page-size-change', pageSize)
    },
    changePage (page) {
      this.currentPage = page
      this.interceptorList.exec()
      //向下兼容
      this.$emit('on-change', page)
      //与iview保持一致
      this.$emit('on-page-change', page)
    },
    onRemote ({request, vm}) {
      //排除内部调用
      request && this.requestCount.push(vm)
      if (!this.request) {
        this.request = request()
      }
      //成功情况下，清空引用
      this.request.then((data) => {
        this.requestCount.forEach(item => {
          item.inOptionList = data
        })
        //清空引用
        this.request = null
        this.requestCount.length = 0
      }).catch((a) => {
      //失败情况下，继续发送
        if (!this.requestCount.length) return
        this.requestCount.shift()
        this.onRemote()
      })
    },
    setData (data) {
      this.data = data
      this.forceRender()
    },
    updateCode (code) {
      this.menuCode = code
    },
    setWipeData (status) {
      this.isWipeData = status
      this.forceRender()
    },
    forceRender () {
      this.currentPage = 1
      this.interceptorList.exec()
    },
    setHeight (height) {
      if (this.setCustomHeight) {
        this.height = this.setCustomHeight(height)
        return
      }
      this.height = height
    },
    onCustomTable (columns) {
      this.forceRender()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/base/variable.scss';
.iv-drag-table {
  /deep/ .ivu-table {
    border-collapse: separate;
    th {
      background-color: #F5F7FA;
      .ivu-table-cell {
        font-size: 16px;
        color: rgba($color: #000000, $alpha: 0.45);
      }
    }
    td, th {
      border-color: #DDDDDD;
      .ivu-table-cell {
        font-size: 14px;
        color: rgba($color: #000000, $alpha: 0.45);
      }
    }
    .ivu-table-tbody > .ivu-table-row:first-child > td {
      background-color: #fff;
    }
  }
}
.iv-transform-search-tip {
  /deep/ .ivu-table-wrapper {
    position: relative;
    .ivu-table-tip {
      width: 100%;
      position: absolute;
      top: 106px;
      left: 0;
      height: 80px !important;
      overflow: hidden !important;
      tbody {
        tr {
          td {
            width: 100% !important;
          }
        }
      }
    }
  }
  // /deep/ .iv-search-showtip {
  //   padding-bottom: 52px;
  // }
}
</style>
